import { Field, FormikProps } from "formik";
import {
  FormContainer,
  FormContainerItem,
  TextField,
} from "@graffer-inc/console-design-kit";
import { ProductNameMap } from "../../../../../../application/domain/organization/org-product";
import { ProductDataRemovableProductCodeLiterals } from "../../../../../../application/domain/product-data-removal-task";

export type ProductDataRemovalTaskFormValues = {
  dueAt: string;
  slug: string;
};

type ProductDataRemovalTaskFormProps = {
  productCode: ProductDataRemovableProductCodeLiterals;
  tenantSlug: string;
  dueAtConfig: {
    readOnly?: boolean;
    minDate?: string;
    maxDate?: string;
  };
  formikProps: FormikProps<ProductDataRemovalTaskFormValues>;
};

export const ProductDataRemovalTaskForm = ({
  productCode,
  tenantSlug,
  dueAtConfig,
  formikProps,
}: ProductDataRemovalTaskFormProps) => {
  const { values, errors, touched, handleChange, handleBlur } = formikProps;

  return (
    <FormContainer>
      <FormContainerItem>
        <TextField
          label="対象製品"
          description={<></>}
          value={ProductNameMap[productCode]}
          placeholder={ProductNameMap[productCode]}
          onChange={() => {
            return;
          }}
          disabled
          readOnly // 製品名は確認用に表示しているので読み取り専用
          required
        />
      </FormContainerItem>
      <FormContainerItem>
        <Field name="dueAt">
          {({ field }: { field: any }) => (
            <TextField
              label="期限日"
              description={
                "翌日から30日後までの間で指定可能です。削除処理でエラーが発生した場合の対応に備え、大型連休直後の指定は避けてください。"
              }
              value={values.dueAt}
              placeholder={"2025-01-15"}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={dueAtConfig.readOnly}
              readOnly={dueAtConfig.readOnly}
              required
              errorMessages={touched.dueAt && errors.dueAt ? errors.dueAt : ""}
              {...field}
              type="date"
              min={dueAtConfig.minDate}
              max={dueAtConfig.maxDate}
            />
          )}
        </Field>
      </FormContainerItem>
      <FormContainerItem>
        <Field name="slug">
          {({ field }: { field: any }) => (
            <TextField
              label="テナントの製品データを削除します。よろしいですか？"
              description={"テナントのスラグを入力してください。"}
              value={values.slug}
              placeholder={tenantSlug}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              errorMessages={touched.slug && errors.slug ? errors.slug : ""}
              {...field}
            />
          )}
        </Field>
      </FormContainerItem>
    </FormContainer>
  );
};
